import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';

@Component({
  selector: 'quorum-gm-my-rewards-offers',
  templateUrl: './gm-my-rewards-offers.component.html',
  styleUrls: ['./gm-my-rewards-offers.component.scss'],
})
export class GmMyRewardsOffersComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<GmMyRewardsOffersComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: { offers$: Observable<any> }
  ) {}

  ngOnInit(): void {}
}
